webpackJsonp([54931016895455],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.ResumePageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Content = __webpack_require__(26);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Logo = __webpack_require__(27);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResumePageTemplate = exports.ResumePageTemplate = function ResumePageTemplate(_ref) {
	  var title = _ref.title,
	      content = _ref.content,
	      contentComponent = _ref.contentComponent,
	      skills = _ref.skills;
	
	  var PageContent = contentComponent || _Content2.default;
	  return _react2.default.createElement(
	    'section',
	    { className: 'section page resume' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container resume-heading' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row justify-content-md-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-3 d-none d-md-block' },
	          _react2.default.createElement('img', { src: '/img/head-shot.jpg', className: 'rounded-circle img-thumbnail' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-9 col-xl-6 align-self-center text-center title' },
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(_Logo2.default, { size: 'xl' }),
	          _react2.default.createElement(
	            'h1',
	            { className: 'subheading text-center' },
	            _react2.default.createElement(
	              'small',
	              null,
	              _react2.default.createElement(
	                'i',
	                null,
	                'MY EXPERIENCE & SKILLSET'
	              )
	            )
	          ),
	          _react2.default.createElement('hr', null)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row resume-content animate fade-in' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-3 well' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-css3', 'aria-hidden': 'true' }),
	            ' Skillset',
	            _react2.default.createElement(
	              'small',
	              { className: 'pull-right' },
	              _react2.default.createElement(
	                'a',
	                { href: '', className: 'text-muted' },
	                _react2.default.createElement('i', { className: 'fa fa-search', 'aria-hidden': 'true' })
	              )
	            )
	          ),
	          skills.map(function (skill) {
	            return _react2.default.createElement(
	              'div',
	              { key: skill.heading },
	              _react2.default.createElement(
	                'strong',
	                { className: 'skill-heading text-accent' },
	                skill.heading
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'list-unstyled' },
	                skill.skills.map(function (item) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: item },
	                    item
	                  );
	                })
	              ),
	              _react2.default.createElement('hr', null)
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-9' },
	          _react2.default.createElement(PageContent, { className: 'content', content: content })
	        )
	      )
	    )
	  );
	};
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	  var post = data.markdownRemark;
	
	  return _react2.default.createElement(ResumePageTemplate, {
	    contentComponent: _Content.HTMLContent,
	    title: post.frontmatter.title,
	    content: post.html,
	    skills: post.frontmatter.skills
	  });
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-resume-page-js-b895c60b5c6bac95266a.js